import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "MedicalWebPage",
   "@id": "https://www.futurefamilyai.com/postpartum/cardiovascular-risk-after-preeclampsia/#webpage",
   "url": "https://www.futurefamilyai.com/postpartum/cardiovascular-risk-after-preeclampsia/",
   "name": "Cardiovascular Risk After Preeclampsia | FutureFamilyAI",
   "description": "A history of preeclampsia is linked to higher long-term heart risk. What the research shows and how to keep your pregnancy history part of your care.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Postpartum & Long-Term Health",
     "item": "https://www.futurefamilyai.com/postpartum/long-term-health/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Cardiovascular Risk After Preeclampsia",
     "item": "https://www.futurefamilyai.com/postpartum/cardiovascular-risk-after-preeclampsia/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Does preeclampsia increase heart disease risk?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, research links preeclampsia with higher long-term cardiovascular risk."
     }
    },
    {
     "@type": "Question",
     "name": "How long after preeclampsia does heart risk last?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Studies show elevated risk for years to decades; ongoing follow-up is recommended."
     }
    },
    {
     "@type": "Question",
     "name": "What should I do after having preeclampsia?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Share your history with your primary-care clinician and keep up blood pressure checks."
     }
    },
    {
     "@type": "Question",
     "name": "Can lifestyle reduce risk after preeclampsia?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Healthy habits help; discuss a plan with your clinician."
     }
    },
    {
     "@type": "Question",
     "name": "Should I take aspirin in a future pregnancy?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Ask your obstetric clinician; low-dose aspirin is sometimes recommended for high-risk pregnancies."
     }
    },
    {
     "@type": "Question",
     "name": "Can FutureFamilyAI predict heart disease?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. It keeps your history and trends organized for your clinician."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function PostpartumCardiovascularRiskAfterPreeclampsiaPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/postpartum/long-term-health">
                Postpartum &amp; Long-Term Health
              </Link>
              <span>›</span>
              <span>Cardiovascular Risk After Preeclampsia</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                A history of preeclampsia is associated with increased future
                cardiovascular risk, including later high blood pressure; one
                meta-analysis found roughly 3.7 times the relative risk of
                hypertension.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Women with prior hypertensive pregnancy</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      A history of preeclampsia was associated with roughly 3.7
                      times the relative risk of developing high blood pressure
                      later in life. (Bellamy et al., BMJ 2007 (PubMed
                      17975258))
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Pregnancy history you can share · Ongoing blood pressure
                      tracking · Heart-health reminders
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">POSTPARTUM GUIDE</span>
            <h1>Cardiovascular Risk After Preeclampsia — Use Your History</h1>
            <p className="ffh-answer speakable-content">
              A history of preeclampsia is associated with increased future
              cardiovascular risk, including later high blood pressure; one
              meta-analysis found roughly 3.7 times the relative risk of
              hypertension. The American Heart Association recognizes adverse
              pregnancy outcomes as heart-risk factors. Tell your primary-care
              clinician about your pregnancy history and keep checking blood
              pressure. FutureFamilyAI keeps that record. Protect your heart
              long-term.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
              <Link className="ffh-btn ffh-ghost" to="/contact-us?type=member">
                Request Free Pilot Access
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Mother protecting her long-term heart health after a preeclampsia pregnancy"
              >
                <figcaption>
                  <b>Photo slot</b> · Woman in her 40s jogging lightly in a park
                  with her school-age child, smartwatch on wrist; long-term
                  health, vitality. No text.
                  <br />
                  <b>Alt:</b> Mother protecting her long-term heart health after
                  a preeclampsia pregnancy
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    A history of preeclampsia was associated with roughly 3.7
                    times the relative risk of developing high blood pressure
                    later in life.
                    <cite>
                      Source:{" "}
                      <a href="https://pubmed.ncbi.nlm.nih.gov/17975258/">
                        Bellamy et al., BMJ 2007 (PubMed 17975258)
                      </a>
                    </cite>
                  </li>
                  <li>
                    Adverse pregnancy outcomes, including preeclampsia, are
                    associated with higher long-term cardiovascular disease
                    risk.
                    <cite>
                      Source:{" "}
                      <a href="https://www.ahajournals.org/doi/10.1161/CIR.0000000000000961">
                        American Heart Association Scientific Statement, 2021
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>What to tell your doctor</h2>
                <ul>
                  <li>You had preeclampsia or gestational hypertension</li>
                  <li>When it occurred</li>
                  <li>Any medications used</li>
                  <li>Postpartum blood pressure trend</li>
                </ul>
              </section>
              <section id="s2">
                <h2>Healthy habits that matter</h2>
                <ul>
                  <li>Regular blood pressure checks</li>
                  <li>Physical activity</li>
                  <li>Heart-healthy diet</li>
                  <li>Annual primary-care visits</li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      Does preeclampsia increase heart disease risk?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Yes, research links preeclampsia with higher long-term
                        cardiovascular risk.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      How long after preeclampsia does heart risk last?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Studies show elevated risk for years to decades; ongoing
                        follow-up is recommended.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      What should I do after having preeclampsia?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Share your history with your primary-care clinician and
                        keep up blood pressure checks.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Can lifestyle reduce risk after preeclampsia?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Healthy habits help; discuss a plan with your clinician.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Should I take aspirin in a future pregnancy?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Ask your obstetric clinician; low-dose aspirin is
                        sometimes recommended for high-risk pregnancies.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can FutureFamilyAI predict heart disease?</summary>
                    <div className="ffh-ans">
                      <p>
                        No. It keeps your history and trends organized for your
                        clinician.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/postpartum/long-term-health">
                    Postpartum &amp; Long-Term Health →
                  </Link>
                  <Link to="/postpartum/postpartum-preeclampsia-symptoms">
                    Postpartum Preeclampsia Symptoms →
                  </Link>
                  <Link to="/postpartum/blood-pressure-after-pregnancy">
                    Blood Pressure After Pregnancy →
                  </Link>
                  <Link to="/postpartum/postpartum-monitoring-timeline">
                    Postpartum Monitoring Timeline →
                  </Link>
                  <Link to="/postpartum/long-term-hypertension-pregnancy-history">
                    Long-Term Hypertension After Pregnancy →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">What to tell your doctor</a>
                  </li>
                  <li>
                    <a href="#s2">Healthy habits that matter</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
